module.exports = __webpack_public_path__ + "img/gyl_common.d9740cad.png";